import * as React from 'react';
import AiAssistantsModal from '../AiAssistantsModal';
import useProfileUsageMetrics from '../../hooks/useProfileUsageMetrics';

function AiAssistantUsage() {
  const { data, error, loading } = useProfileUsageMetrics();

  const earningsCallMeter = data?.earnings_call_usage_meter;
  const analystMeter = data?.financial_analyst_usage_meter;
  const secFilingMeter = data?.sec_filing_usage_meter;

  const bonus_questions = earningsCallMeter?.bonus_questions;
  const premium_questions = earningsCallMeter?.premium_questions;
  const bonus_analyst_questions = analystMeter?.bonus_questions;
  const premium_analyst_questions = analystMeter?.premium_questions;
  const bonus_sec_filing_questions = secFilingMeter?.bonus_questions;
  const premium_sec_filing_questions = secFilingMeter?.premium_questions;
  const user_plan = earningsCallMeter?.user_plan;

  function questions_percentage(used, max) {
    if (!max || max === 0 || used === undefined || used === null) {
      return 0;
    }
    return Math.round((used / max) * 100);
  }

  function bonus_questions_percentage() {
    if (!bonus_questions) { return 0; }
    return questions_percentage(bonus_questions.used, bonus_questions.max);
  }

  function premium_questions_percentage() {
    if (!premium_questions) { return 0; }
    return questions_percentage(premium_questions.used, premium_questions.max);
  }

  return (
    <div className="py-4 border-bottom">
      <p className="clearfix">
        <div className="card">
          <div className="card-body">
            <h4 className="card-title"><strong>AI Usage</strong></h4>
            <p className="page-description">Questions/Tasks asked to AI Assistants. <AiAssistantsModal message="Learn more"/></p>
            { loading ? (
              <div>Loading usage metrics...</div>
            ) : error || !bonus_questions || !bonus_analyst_questions || !bonus_sec_filing_questions ? (
              <div>Usage metrics are unavailable at the moment.</div>
            ) : (
              <div className="template-demo">
                <div className="d-flex justify-content-between">
                  <small>Saturday - bonus questions</small>
                  <small>{bonus_questions.used + '/' + bonus_questions.max}</small>
                </div>
                <div className="progress progress-lg mt-2">
                  <div className="progress-bar bg-danger" role="progressbar" style={{ 'width': bonus_questions_percentage() + '%'}}>{bonus_questions_percentage() + '%'}</div>
                </div>
                <div className="d-flex justify-content-between">
                  <small>Lima - bonus questions</small>
                  <small>{bonus_analyst_questions.used + '/' + bonus_analyst_questions.max}</small>
                </div>
                <div className="progress progress-lg mt-2">
                  <div className="progress-bar bg-danger" role="progressbar" style={{ 'width': questions_percentage(bonus_analyst_questions.used, bonus_analyst_questions.max) + '%'}}>{questions_percentage(bonus_analyst_questions.used, bonus_analyst_questions.max) + '%'}</div>
                </div>

                <div className="d-flex justify-content-between">
                  <small>June - bonus questions</small>
                  <small>{bonus_sec_filing_questions.used + '/' + bonus_sec_filing_questions.max}</small>
                </div>
                <div className="progress progress-lg mt-2">
                  <div className="progress-bar bg-danger" role="progressbar" style={{ 'width': questions_percentage(bonus_sec_filing_questions.used, bonus_sec_filing_questions.max) + '%'}}>{questions_percentage(bonus_sec_filing_questions.used, bonus_sec_filing_questions.max) + '%'}</div>
                </div>
                { user_plan == 'premium' && premium_questions && premium_analyst_questions && premium_sec_filing_questions ? (
                  <span>
                    <div className="d-flex justify-content-between mt-2">
                      <small>Saturday - premium questions (This month)</small>
                      <small>{premium_questions.used + '/' + premium_questions.max}</small>
                    </div>
                    <div className="progress progress-lg mt-2">
                      <div className="progress-bar bg-danger" role="progressbar" style={{ 'width': premium_questions_percentage() + '%'}}>{premium_questions_percentage() + '%'}</div>
                    </div>
                    <div className="d-flex justify-content-between mt-2">
                      <small>Lima - premium questions (This month)</small>
                      <small>{premium_analyst_questions.used + '/' + premium_analyst_questions.max}</small>
                    </div>
                    <div className="progress progress-lg mt-2">
                      <div className="progress-bar bg-danger" role="progressbar" style={{ 'width': questions_percentage(premium_analyst_questions.used, premium_analyst_questions.max) + '%'}}>{questions_percentage(premium_analyst_questions.used, premium_analyst_questions.max) + '%'}</div>
                    </div>


                    <div className="d-flex justify-content-between mt-2">
                      <small>June - premium questions (This month)</small>
                      <small>{premium_sec_filing_questions.used + '/' + premium_sec_filing_questions.max}</small>
                    </div>
                    <div className="progress progress-lg mt-2">
                      <div className="progress-bar bg-danger" role="progressbar" style={{ 'width': questions_percentage(premium_sec_filing_questions.used, premium_sec_filing_questions.max) + '%'}}>{questions_percentage(premium_sec_filing_questions.used, premium_sec_filing_questions.max) + '%'}</div>
                    </div>
                  </span>
                ) : null}
              </div>
            )}
            { (user_plan == 'free' || user_plan == 'premium') && earningsCallMeter ? (
              <div className='mt-2'>
                <p className="card-description"><small>{earningsCallMeter.next_steps} <a href="/pricing">here</a>.</small></p>
              </div>
            ) : null}
          </div>
        </div>
      </p>
    </div>
  );
}

export default AiAssistantUsage;
